(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider
    .state('relatorioAvalOrgao', {
         url: "/relatorioAvaliacaoOrgao",
         templateUrl: 'module/corregedoria/relatorioAvalOrgao/relatorioAvalOrgao.html',
         controller: 'RelatorioAvalOrgao',
         controllerAs: 'vm'
     });
  }

})();
